const IGNORED_ROUTES = [
  // '/publications',
];

export const checkIfUrlIsIgnored = (url = '') => {
  let isValid = false;

  IGNORED_ROUTES.forEach((u) => {
    if (url.includes(u)) {
      isValid = true;
      return;
    }
  });

  return isValid;
}